import { CourseCatalog } from './course-catalog.model';

export class CourseCatalogCommand {
    title_translations: {
        'translation_en-GB': string;
        'translation_de-DE': string;
        'translation_fr-FR': string;
        'translation_it-CH': string;
    };
    visible_to_users: boolean;
    currency?: string;

    constructor(query: CourseCatalog) {
        this.title_translations = { ...query.titleTranslations };
        this.visible_to_users = query.visibleToUsers;
        this.currency = query.currency;
    }
}
